export const LeaseTemplateEnum = {
    leaseName: 0,
    rental: 1,
    commencementDate: 2,
    endDate: 3,
    annuity: 4,
    ibr: 5,
    frequency: 6,
    increment: 7,
    idc: 8,
    grv: 9,
    incrementalFrequency: 10,
    rouOpening: 11,
    rouExRate: 12,
    currencyCode: 13,
    assetType:14
};
export const LeaseIRTemplateEnum = {
    serialNo: 0,
    paymentDate: 1,
    rental: 2,
};
